import { useEffect, useState } from 'react';

import { resetShare, shareInitialization } from './methods/shareInitialization';
import { shareContext$ } from './shareContext';
import { ShareState } from './types';

/**
 * useShareContext реализует хук для подключения стейта шаринга.
 */
export const useShareContext = () => {
  const [state, setState] = useState<ShareState>(shareContext$.getValue());
  useEffect(() => {
    const subscription = shareContext$.pipe().subscribe({
      next: (nState) => setState(nState),
    });

    return () => {
      try {
        subscription?.unsubscribe();
      } catch (e) {}
    };
  }, []);

  return {
    state,
    shareInitialization,
    resetShare,
  };
};
